$.fn.FeaturedItems = function() {
  let self = this
  self.button = $('.featured-items__expand-button')
  self.more_content = $('.featured-more-items')

  self.open = function() {
    self.button.attr('aria-expanded', 'true')
    self.more_content.attr('aria-hidden', 'false').hide()
    self.button.fadeOut(250, function() {
      self.button.show().css('visibility', 'hidden')
      self.more_content.slideDown(250)
      self.more_content.fadeIn(250)
    });
  }

  return function() {
    self.button.on('click', self.open)
    return self
  }()
}
